import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconSakhirMinimapMarkers = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={376}
    height={375}
    fill="none"
    viewBox="0 0 376 375"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#icon-sakhir-minimap-markers_svg__a)">
      <path
        fill="url(#icon-sakhir-minimap-markers_svg__b)"
        fillOpacity={0.2}
        stroke="#fff"
        strokeOpacity={0.1}
        strokeWidth={10}
        d="M40.137 175.748c-1.624 11.112-5.569 38.965-7.338 51.502-1.125 6.742-.677 12.381-.313 14.358A1687.881 1687.881 0 0 0 38.136 258c.943 2.677 1.735 4.87 2.157 5.926 1.25 3.121 0 5.358-.78 6.086L28.58 282.5l-2.184 2.495c-2.186 2.497-.468 5.306 4.372 5.774 1.134.11 17.101.269 41.064.401 20.045.109 45.685.199 72.917.223 79.199.071 171.748-.223 178.154-.312a31.585 31.585 0 0 0 3.057-.191c9.687-1.076 16.837-6.32 20.52-8.08 3.591-1.717 4.059-3.278 4.059-4.838 0-1.158-1.584-3.979-2.756-5.972-.408-.694-.767-1.287-.991-1.676-2.097-3.627-5.861-9.92-9.418-15.824a2427.213 2427.213 0 0 0-7.913-13.048c-2.967-4.838-28.574-46.196-33.414-54.311-5.836-9.785-37.738-61.218-42.043-68.141l-.427-.685c-1.208-1.932-5.873-11.523-12.117-16.128-1.827-1.347-3.789-2.267-5.839-2.444-2.811-.242-5.533.761-8.012 2.444-3.91 2.655-7.217 7.001-9.319 10.822a400.302 400.302 0 0 1-1.623 3.491c-1.478 3.14-2.833 5.953-5.247 11.335-2.555 5.698-3.506 7.261-4.936 11.165-.388 1.058-.81 2.287-1.31 3.818-3.027 9.28-.274 20.6 4.997 28.716 5.777 8.896 16.349 12.423 26.543 15.607 5.687 1.776 10.525 3.58 14.677 6.554 7.495 5.37 10.93 10.145 14.053 16.856.873 1.876 1.394 4.399 1.873 6.086 1.441 5.068 1.186 9 .332 12.363-.348 1.371-.796 2.648-1.268 3.868-1.453 3.752-5.505 4.939-8.731 5.307a26.25 26.25 0 0 1-2.511.156c-4.183-.054-11.44-.094-18.904-.12a5908.09 5908.09 0 0 0-19.038-.036c-11.598 0-79.969.125-98.237.151l-4.19.005c-4.996 0-6.401-.055-12.335-.469-7.17-.5-16.22-1.519-22.475-2.3-3.687-.461-6.403-.838-7.191-.977-2.654-.468-3.123-3.173-.937-6.087.837-1.114 1.42-1.986 2.183-2.998.816-1.08 1.838-2.318 3.594-4.181 2.03-2.341 4.372-4.994 7.183-6.398 4.24-2.119 8.145-2.927 13.428-2.654 5.919.306 13.598 1.387 16.238 1.717 2.641.33 17.275 2.055 31.502 3.7 12.692 1.468 25.06 2.873 28.299 3.167 4.175.38 7.312-.74 9.201-2.272 1.219-.989 1.918-2.149 2.041-3.19.25-2.123-1.666-4.11-2.654-4.838-4.592-3.443-10.87-8.008-17.152-12.551-10.807-7.815-21.63-15.564-23.913-17.414-1.529-1.239-2.794-2.5-3.822-3.823-2.858-3.677-3.889-7.836-3.672-13.345.312-7.959 1.89-9.872.78-17.635-.937-6.555-5.74-9.92-11.086-12.173-2.187-.922-4.986-1.785-6.87-2.341-4.648-1.373-7.614-3.532-9.652-5.316-.974-.853-1.737-1.62-2.37-2.176-3.383-2.965-10.15-9.02-13.272-12.017-.25-.239-.537-.525-.858-.851-4.7-4.782-16.497-18.252-19.128-21.466-.712-.87-1.68-1.978-3.119-2.943-1.814-1.217-4.378-2.207-8.123-2.207-3.423 0-5.57 1.546-6.714 3.433-1.704 2.81-1.405 7.179-2.498 12.173-.334 1.529-1.208 7.088-2.336 14.601-2.889 19.231-7.446 51.26-8.906 61.248Z"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M30.77 290.708c1.133.109 17.1.269 41.064.4"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M71.834 290.877c20.045.11 45.685.2 72.917.224 79.198.07 171.747-.223 178.153-.312a31.927 31.927 0 0 0 3.058-.191"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M346.481 282.518c-3.683 1.76-10.833 7.004-20.52 8.08"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M346.48 282.517c3.592-1.716 4.06-3.277 4.06-4.838 0-1.157-1.584-3.978-2.756-5.971"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M337.375 254.208c3.558 5.903 7.321 12.196 9.418 15.824.225.388.583.982.991 1.676"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="m253.578 118.022.427.685 42.043 68.141c4.84 8.116 30.447 49.473 33.413 54.311 1.435 2.339 4.584 7.523 7.914 13.048"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="m254.005 118.707-.427-.684c-1.208-1.932-5.873-11.524-12.117-16.128"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M241.46 101.895c-1.827-1.347-3.788-2.268-5.838-2.444-2.812-.243-5.533.761-8.013 2.444"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M227.61 101.895c-3.91 2.655-7.217 7.001-9.319 10.821a374.652 374.652 0 0 1-1.623 3.491"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M216.667 116.208c-1.477 3.14-2.833 5.953-5.246 11.335-2.556 5.698-3.506 7.26-4.937 11.165"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M210.172 171.241c-5.271-8.115-8.024-19.435-4.997-28.716.5-1.53.922-2.76 1.31-3.817"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M265.445 210.258c-3.123-6.711-6.558-11.486-14.053-16.855-4.152-2.975-8.99-4.779-14.677-6.555-10.194-3.184-20.766-6.711-26.543-15.607"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M265.445 210.258c.873 1.876 1.394 4.4 1.874 6.087 1.441 5.068 1.185 9 .331 12.363"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M267.649 228.708c-.348 1.371-.795 2.647-1.268 3.868-1.453 3.752-5.504 4.938-8.731 5.306"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M257.65 237.882c-.934.106-1.799.144-2.512.156-4.182-.054-11.439-.094-18.904-.12"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M236.236 237.918a5908.09 5908.09 0 0 0-19.038-.036c-11.598 0-79.969.125-98.237.151"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="m118.961 238.034-4.19.005c-4.996 0-6.401-.055-12.335-.469-7.17-.5-16.22-1.52-22.475-2.3"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M79.962 235.269c-3.688-.46-6.404-.838-7.191-.976-2.655-.469-3.123-3.174-.937-6.087.837-1.115 1.42-1.987 2.183-2.998"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M98.22 211.975c-5.283-.273-9.188.534-13.428 2.653-2.81 1.405-5.153 4.058-7.183 6.399-1.756 1.862-2.778 3.101-3.593 4.181"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M98.22 211.975c5.92.306 13.599 1.387 16.239 1.717 2.641.33 17.275 2.055 31.502 3.7"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M145.961 217.392c12.692 1.467 25.06 2.872 28.299 3.166 4.175.38 7.312-.74 9.201-2.271"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M182.848 210.258c.989.729 2.904 2.716 2.654 4.838-.122 1.041-.822 2.202-2.041 3.191"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M182.847 210.258c-4.592-3.442-10.869-8.007-17.152-12.55"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M165.696 197.708c-10.807-7.815-21.63-15.564-23.913-17.414-1.529-1.239-2.794-2.5-3.822-3.823"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M137.961 176.47c-2.858-3.677-3.889-7.835-3.672-13.344.312-7.96 1.89-9.872.78-17.636-.937-6.555-5.74-9.92-11.086-12.173-2.187-.922-4.986-1.785-6.87-2.341-4.648-1.373-7.614-3.531-9.652-5.316"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M107.461 125.66c-.974-.852-1.737-1.62-2.37-2.175-3.383-2.965-10.15-9.021-13.272-12.017-.25-.239-.537-.525-.858-.852"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M68.715 86.207c1.439.966 2.407 2.074 3.119 2.943 2.63 3.214 14.428 16.685 19.127 21.466"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M53.877 87.433C55.021 85.547 57.167 84 60.591 84c3.744 0 6.308.99 8.123 2.207"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M53.878 87.434c-1.705 2.809-1.406 7.179-2.498 12.173-.335 1.529-1.209 7.088-2.337 14.601"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M49.041 114.208c-2.888 19.23-7.445 51.259-8.905 61.247l-7.339 51.502c-1.124 6.743-.676 12.382-.312 14.359a1687.881 1687.881 0 0 0 5.65 16.392"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="m38.137 257.708 2.157 5.925c1.25 3.122 0 5.358-.78 6.087l-10.932 12.488"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M30.769 290.477c-4.84-.469-6.558-3.278-4.372-5.775l2.064-2.494"
      />
      <g filter="url(#icon-sakhir-minimap-markers_svg__c)">
        <path
          fill="#fff"
          fillOpacity={0.95}
          d="M178.573 272h4.028v4.526h-4.028zM178.573 281.052h4.028v4.526h-4.028zM178.573 290.103h4.028v4.526h-4.028zM178.573 299.155h4.028v4.526h-4.028zM178.573 308.206h4.028v4.526h-4.028zM182.602 276.526h4.028v4.526h-4.028zM182.602 285.577h4.028v4.526h-4.028zM182.602 294.629h4.028v4.526h-4.028zM182.602 303.68h4.028v4.526h-4.028z"
        />
        <path
          fill="#000"
          d="M182.602 272h4.028v4.526h-4.028zM182.602 281.052h4.028v4.526h-4.028zM182.602 290.103h4.028v4.526h-4.028zM182.602 299.155h4.028v4.526h-4.028zM182.602 308.206h4.028v4.526h-4.028zM178.573 276.526h4.028v4.526h-4.028zM178.573 285.577h4.028v4.526h-4.028zM178.573 294.629h4.028v4.526h-4.028zM178.573 303.68h4.028v4.526h-4.028z"
        />
        <path
          fill="#E2645A"
          d="m152.64 318.382 14.82 9.856v-19.761l-14.82 9.905Zm-2.263 0c0-.728.299-1.408.897-1.796l15.545-10.342c1.196-.826 2.691.145 2.691 1.748v20.78c0 1.554-1.495 2.574-2.691 1.797l-15.545-10.391a2.207 2.207 0 0 1-.897-1.796Z"
        />
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__d)">
        <rect
          width={20}
          height={20}
          x={5.5}
          y={294}
          fill="url(#icon-sakhir-minimap-markers_svg__e)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__f)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m15.327 301.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__g)">
        <rect
          width={20}
          height={20}
          x={49.5}
          y={261}
          fill="url(#icon-sakhir-minimap-markers_svg__h)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__i)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m56.505 273.236 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V275h-5.784v-1.764Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__j)">
        <rect
          width={20}
          height={20}
          x={5.5}
          y={230}
          fill="url(#icon-sakhir-minimap-markers_svg__k)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__l)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M12.287 242.764v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L17.05 244h-3.528l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__m)">
        <rect
          width={20}
          height={20}
          x={42.5}
          y={57}
          fill="url(#icon-sakhir-minimap-markers_svg__n)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__o)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M53.207 69.392h-4.08V67.82l3.684-5.22H54.6v5.592h1.02v1.2H54.6V71h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__p)">
        <rect
          width={20}
          height={20}
          x={91.5}
          y={135}
          fill="url(#icon-sakhir-minimap-markers_svg__q)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__r)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M98.39 147.764v-1.224h1.391v.804l.468.456h2.256l.468-.456v-2.064l-.468-.468h-3.996V140.6h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904L103.129 149h-3.504l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__s)">
        <rect
          width={20}
          height={20}
          x={144.5}
          y={132}
          fill="url(#icon-sakhir-minimap-markers_svg__t)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__u)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M151.409 144.764v-5.928l1.236-1.236h3.528l1.236 1.236v1.104h-1.392v-.66l-.48-.48h-2.256l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772L156.221 146h-3.576l-1.236-1.236Zm4.176.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.304Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__v)">
        <rect
          width={20}
          height={20}
          x={112.5}
          y={173}
          fill="url(#icon-sakhir-minimap-markers_svg__w)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__x)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M123.661 180.028v-.228h-4.248v-1.2h5.688v1.464L121.753 187h-1.464l3.372-6.972Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__y)">
        <rect
          width={20}
          height={20}
          x={193.5}
          y={209}
          fill="url(#icon-sakhir-minimap-markers_svg__z)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__A)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M200.256 221.764v-2.34l.756-.756-.636-.636v-2.196l1.236-1.236h3.528l1.236 1.236v2.196l-.636.636.756.756v2.34L205.26 223h-3.768l-1.236-1.236Zm4.248-3.612.48-.48v-1.392l-.48-.48h-2.256l-.48.48v1.392l.48.48h2.256Zm.12 3.648.48-.48v-1.524l-.48-.468h-2.496l-.48.468v1.524l.48.48h2.496Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__B)">
        <rect
          width={20}
          height={20}
          x={68.5}
          y={189}
          fill="url(#icon-sakhir-minimap-markers_svg__C)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__D)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M75.44 201.764v-1.02h1.392v.576l.48.48h2.184l.48-.48v-2.172l-.744.744h-2.676l-1.236-1.236v-2.82l1.236-1.236h3.576l1.236 1.236v5.928L80.132 203h-3.456l-1.236-1.236Zm3.648-3.072.888-.888v-1.524l-.48-.48h-2.304l-.48.48v1.932l.48.48h1.896Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__E)">
        <rect
          width={20}
          height={20}
          x={44.5}
          y={220}
          fill="url(#icon-sakhir-minimap-markers_svg__F)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__G)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m50.34 227.076-1.836.948v-1.284l2.077-1.14h1.151v8.4H50.34v-6.924Zm3.263 5.592v-5.736l1.332-1.332h3.624l1.332 1.332v5.736L58.559 234h-3.624l-1.332-1.332Zm4.308.132.588-.576v-4.848l-.588-.576h-2.328l-.588.576v4.848l.588.576h2.328Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__H)">
        <rect
          width={20}
          height={20}
          x={275.5}
          y={219}
          fill="url(#icon-sakhir-minimap-markers_svg__I)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__J)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m282.958 226.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm4.738 0-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__K)">
        <rect
          width={20}
          height={20}
          x={180.5}
          y={168}
          fill="url(#icon-sakhir-minimap-markers_svg__L)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__M)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m186.803 175.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.071 5.16 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V182h-5.784v-1.764Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__N)">
        <rect
          width={20}
          height={20}
          x={212.5}
          y={74}
          fill="url(#icon-sakhir-minimap-markers_svg__O)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__P)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m218.634 81.076-1.836.948V80.74l2.076-1.14h1.152V88h-1.392v-6.924Zm3.022 5.688v-1.188h1.392v.768l.468.456h2.28l.468-.456V84.82l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L226.42 88h-3.528l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__Q)">
        <rect
          width={20}
          height={20}
          x={347.5}
          y={289}
          fill="url(#icon-sakhir-minimap-markers_svg__R)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__S)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m353.774 296.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm6.802 5.316h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02V303h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
          />
        </g>
      </g>
      <g filter="url(#icon-sakhir-minimap-markers_svg__T)">
        <rect
          width={20}
          height={20}
          x={311.5}
          y={299}
          fill="url(#icon-sakhir-minimap-markers_svg__U)"
          rx={10}
        />
        <g filter="url(#icon-sakhir-minimap-markers_svg__V)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m317.616 306.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.142 5.688v-1.224h1.392v.804l.468.456h2.256l.468-.456v-2.064l-.468-.468h-3.996V304.6h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904L325.498 313h-3.504l-1.236-1.236Z"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="icon-sakhir-minimap-markers_svg__c"
        width={58.253}
        height={80.835}
        x={139.377}
        y={265}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={3}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={4} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__d"
        width={36}
        height={36}
        x={-2.5}
        y={288}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__f"
        width={19.227}
        height={24.4}
        x={5.491}
        y={293.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__g"
        width={36}
        height={36}
        x={41.5}
        y={255}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__i"
        width={21.831}
        height={24.4}
        x={48.457}
        y={260.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__j"
        width={36}
        height={36}
        x={-2.5}
        y={224}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__l"
        width={22}
        height={24.4}
        x={4.287}
        y={229.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__m"
        width={36}
        height={36}
        x={34.5}
        y={51}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__o"
        width={22.492}
        height={24.4}
        x={41.127}
        y={56.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__p"
        width={36}
        height={36}
        x={83.5}
        y={129}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__r"
        width={21.977}
        height={24.4}
        x={90.389}
        y={134.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__s"
        width={36}
        height={36}
        x={136.5}
        y={126}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__u"
        width={22.048}
        height={24.4}
        x={143.409}
        y={131.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__v"
        width={36}
        height={36}
        x={104.5}
        y={167}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__x"
        width={21.688}
        height={24.4}
        x={111.413}
        y={172.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__y"
        width={36}
        height={36}
        x={185.5}
        y={203}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__A"
        width={22.24}
        height={24.4}
        x={192.256}
        y={208.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__B"
        width={36}
        height={36}
        x={60.5}
        y={183}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__D"
        width={22.048}
        height={24.4}
        x={67.32}
        y={188.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__E"
        width={36}
        height={36}
        x={36.5}
        y={214}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__G"
        width={27.386}
        height={24.4}
        x={40.505}
        y={219.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__H"
        width={36}
        height={36}
        x={267.5}
        y={213}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__J"
        width={23.966}
        height={24.4}
        x={273.122}
        y={218.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__K"
        width={36}
        height={36}
        x={172.5}
        y={162}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__M"
        width={26.689}
        height={24.4}
        x={176.968}
        y={167.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__N"
        width={36}
        height={36}
        x={204.5}
        y={68}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__P"
        width={26.858}
        height={24.4}
        x={208.798}
        y={73.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__Q"
        width={36}
        height={36}
        x={339.5}
        y={283}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__S"
        width={27.05}
        height={24.4}
        x={343.938}
        y={288.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__T"
        width={36}
        height={36}
        x={303.5}
        y={293}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <filter
        id="icon-sakhir-minimap-markers_svg__V"
        width={26.954}
        height={24.4}
        x={307.78}
        y={298.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_47810"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_47810"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_47810"
          result="effect2_dropShadow_9632_47810"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_47810"
          result="shape"
        />
      </filter>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__b"
        x1={25.461}
        x2={350.54}
        y1={188.854}
        y2={188.854}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4FC5BA" />
        <stop offset={1} stopColor="#4FC5BA" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__e"
        x1={25.5}
        x2={5.5}
        y1={294}
        y2={314}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__h"
        x1={69.5}
        x2={49.5}
        y1={261}
        y2={281}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__k"
        x1={25.5}
        x2={5.5}
        y1={230}
        y2={250}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__n"
        x1={62.5}
        x2={42.5}
        y1={57}
        y2={77}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__q"
        x1={111.5}
        x2={91.5}
        y1={135}
        y2={155}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__t"
        x1={164.5}
        x2={144.5}
        y1={132}
        y2={152}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__w"
        x1={132.5}
        x2={112.5}
        y1={173}
        y2={193}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__z"
        x1={213.5}
        x2={193.5}
        y1={209}
        y2={229}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__C"
        x1={88.5}
        x2={68.5}
        y1={189}
        y2={209}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__F"
        x1={64.5}
        x2={44.5}
        y1={220}
        y2={240}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__I"
        x1={295.5}
        x2={275.5}
        y1={219}
        y2={239}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__L"
        x1={200.5}
        x2={180.5}
        y1={168}
        y2={188}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__O"
        x1={232.5}
        x2={212.5}
        y1={74}
        y2={94}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__R"
        x1={367.5}
        x2={347.5}
        y1={289}
        y2={309}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-sakhir-minimap-markers_svg__U"
        x1={331.5}
        x2={311.5}
        y1={299}
        y2={319}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <clipPath id="icon-sakhir-minimap-markers_svg__a">
        <path fill="#fff" d="M.5 0h375v375H.5z" />
      </clipPath>
    </defs>
  </svg>
));
export default SvgIconSakhirMinimapMarkers;
